import { render, staticRenderFns } from "./termService.vue?vue&type=template&id=261274c6&scoped=true&"
import script from "./termService.vue?vue&type=script&lang=js&"
export * from "./termService.vue?vue&type=script&lang=js&"
import style0 from "./termService.vue?vue&type=style&index=0&id=261274c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261274c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
